import React, { useContext, useEffect, useState } from "react";
import { Box, Container, Paper, Typography, MenuItem } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import AllItems from "../../product/component/AllItems";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import PosCartLineItem, {
  PosCartLineItemDetails,
} from "../../common/component/lineitem/PosCartLineItem";
import AddPaymentMethod from "../../common/screen/AddPaymentMethod";
import ButtonWithConfirmation from "../../common/ButtonWithConfirmation";
import StandardItem from "../../product/component/StandardItem";
import CustomItem from "../../product/component/CustomItem";
import currency from "currency.js";
import SaveDraftOrder from "../component/SaveDraftOrder";
import MoreOptions from "../../common/component/MoreOptions";
import { Link as RouterLink } from "react-router-dom";
import BookmarksOutlinedIcon from "@mui/icons-material/BookmarksOutlined";
import BookmarkAddOutlinedIcon from "@mui/icons-material/BookmarkAddOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import { getDataFromLocalStorage, setDataInLocalStorage } from "../../common/util";

export default function POS(props) {
  const navigate = useNavigate();
  let location = useLocation();

  const theme = useTheme();
  const posMode = useMediaQuery(theme.breakpoints.up("sm"));

  const { user } = useContext(UserContext);

  const [items, setItems] = useState([]);
  const [reqId, setReqId] = useState("");
  const [paymentMethodKey, setPaymentMethodKey] = useState(0);

  useEffect(() => {
    if (location.state) {
      setItems(location.state.items);
      //setCustomer(location.state.customer);
      //setFulfillment({ ...fulfillment, date: location.state.fulfillment?.date });
      //setReqId(location.state.reqId);
    } else {
      const cache = getDataFromLocalStorage("cart", 5 * 60 * 1000);
      if (cache && cache.items) {
        setItems(cache.items);
      } else {
        setItems([]);
      }
      /*setFulfillment({
        type: posMode ? "togo" : "pickup",
        date: posMode ? moment().format("YYYY-MM-DD") : "",
        address: posMode ? user.config.storeLocation[0].address : "",
        location: posMode ? user.config.storeLocation[0].address : ""
      });*/
    }
  }, [location.key]);

  const updateCache = (items) => {
    setDataInLocalStorage("cart", { items });
  };

  const replaceItem = (idx, item) => {
    const arr = [...items];
    arr[idx] = item;
    setItems(arr);
    updateCache(arr);
  };

  const removeItem = (idx) => {
    const arr = [...items];
    arr.splice(idx, 1);
    setItems(arr);
    updateCache(arr);
  };

  return (
    <Container maxWidth={false} sx={{ overflow: "visible" }}>
      <Box my={2}>
        <Box sx={{ display: "flex", gap: "20px", alignItems: "stretch" }}>
          <Box sx={{ flex: "1 1 0%", minWidth: 0 }}>
            <AllItems
              includeCustom={true}
              onChange={(item) => {
                const arr = [...items];
                arr.push(item);
                setItems(arr);
                updateCache(arr);
              }}
            />
          </Box>
          <Box sx={{ flexShrink: 0, width: 300 }}>
            <Box
              sx={{
                position: "sticky",
                top: 0,
                zIndex: 900,
                alignSelf: "flex-start",
                width: 300,
              }}
            >
              <Paper elevation={0} sx={{ border: "2px dotted #CCC", width: "300px" }}>
                <Box
                  sx={{
                    height: "75vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    overflowY: "auto",
                  }}
                >
                  <Box
                    pl={1}
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  >
                    <Box py={1} sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      {items.length > 0 ? (
                        <Typography variant="overline">
                          {items.length} item(s) |{" "}
                          {currency(items.reduce((acc, o) => +acc + +o.total, 0)).format()}
                        </Typography>
                      ) : (
                        <Typography variant="body1" color="textSecondary">
                          New Sale
                        </Typography>
                      )}
                    </Box>
                    <MoreOptions>
                      <MenuItem sx={{ padding: "20px" }} component={RouterLink} to={`/order/draft`}>
                        <BookmarksOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
                        View Drafts
                      </MenuItem>
                      <SaveDraftOrder
                        items={items}
                        disabled={items.length === 0}
                        onSubmit={() => {
                          localStorage.removeItem("cart");
                          setPaymentMethodKey((prev) => prev + 1); // Force remount of AddPaymentMethod
                          navigate(location.pathname, { replace: true });
                        }}
                      >
                        <MenuItem sx={{ padding: "20px" }} disabled={items.length === 0}>
                          <BookmarkAddOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
                          Save Draft
                        </MenuItem>
                      </SaveDraftOrder>
                      <ButtonWithConfirmation
                        copy="Are you sure you want to clear this entry?"
                        onConfirm={() => {
                          localStorage.removeItem("cart");
                          setPaymentMethodKey((prev) => prev + 1); // Force remount of AddPaymentMethod
                          navigate(location.pathname, { replace: true });
                        }}
                        disabled={items.length === 0}
                      >
                        <MenuItem sx={{ padding: "20px" }} disabled={items.length === 0}>
                          <ClearOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
                          Clear Current Sale
                        </MenuItem>
                      </ButtonWithConfirmation>
                    </MoreOptions>
                  </Box>
                  <Box sx={{ flexGrow: "1", borderTop: "1px solid #DDD" }}>
                    <Box>
                      {(!items || items.length === 0) && (
                        <Box p={2} py={4} sx={{ textAlign: "center" }}>
                          <ShoppingBagOutlinedIcon sx={{ fontSize: "3rem", color: "#999" }} />
                          <Typography variant="h5" gutterBottom color="textSecondary">
                            No items yet!
                          </Typography>
                        </Box>
                      )}
                      {items.map((o, idx) => (
                        <Box py={2} pr={0.4} key={idx}>
                          <PosCartLineItem
                            item={o}
                            user={user}
                            onQuantityCommit={(updated) => replaceItem(idx, updated)}
                            onDelete={() => removeItem(idx)}
                          >
                            {o.productId ? (
                              <StandardItem
                                item={o}
                                onChange={(updated) =>
                                  updated ? replaceItem(idx, updated) : removeItem(idx)
                                }
                              >
                                <PosCartLineItemDetails item={o} />
                              </StandardItem>
                            ) : (
                              <CustomItem
                                item={o}
                                onChange={(updated) =>
                                  updated ? replaceItem(idx, updated) : removeItem(idx)
                                }
                              >
                                <PosCartLineItemDetails item={o} />
                              </CustomItem>
                            )}
                          </PosCartLineItem>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </Paper>
              <Box my={1}>
                <AddPaymentMethod
                  key={paymentMethodKey}
                  items={items}
                  disabled={items.length === 0}
                  onSaleComplete={() => setItems([])}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
